import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.section`
  padding: var(--layout-01);
  overflow: hidden;
  overflow-y: auto;
`;

export const Home: FC = () => (
  <Wrapper>
    <h2>Ozone</h2>
    <p>The design system for rocketlane</p>
  </Wrapper>
);
